<template>
  <div class="Activity">
    <div class="presentationActivity">
      <PresentationBox
        :presentationData="item"
        v-for="item in presentationList"
        :key="item.id"
      />
    </div>
  </div>
</template>
<script>
import PresentationBox from "../components/presentationBox.vue";
export default {
  name: "Activity",
  components: {
    PresentationBox,
  },
  data() {
    return {
      presentationList: [],
      lan: this.$store.state.isEn,
    };
  },
  watch: {
    "$store.state.isEn"() {
      this.lan = this.$store.state.isEn;
    },
  },
  mounted() {
    this.init();
  },

  methods: {
    async init() {
      try {
        await this.$api.get(
          "/activity/list",
          { current: 1, pageSize: 10, activityType: 1 },
          (r) => {
            const { data, code } = r;
            if (code == 0) {
              this.presentationList = data;
            }
          }
        );
      } catch (error) {
        console.error("Failed to fetch activity list:", error);
      }
    },
  },
};
</script>

<style scoped>
.Activity {
  margin: 154px auto 60px;
  width: 1460px;
}
.presentationActivity {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  justify-content: space-between;
}
@media (max-width: 1480px) {
  .Activity {
    margin: 100px auto 30px;
    width: 95%;
  }
  .presentationActivity {
    transform: scaleX(0.9);
    justify-content: space-between;
  }
}
@media (max-width: 960px) {
  .presentationActivity {
    transform: scaleX(1);
    justify-content: space-between;
  }
  .Activity {
    margin: 100px auto 30px;
    width: 99%;
  }
}
</style>
